import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function Careers_All(){

    const [ contacts, setContacts ] =useState([]);
    const [ loading, setLoading ] = useState(true);

	useEffect(() => {
		window.scrollTo(0, 0)

        const fetchContacts = async () => {
            try {
                setContacts(contacts);
                const response = await axios.get(`${process.env.REACT_APP_API}/careers/all`);
                // console.log(response.data);
                setContacts(response.data);
                setLoading(false);
            } 
            catch (e) {
                console.log(e);
                setContacts(contacts);
            }
        };

        fetchContacts();

	}, [])

    return (
        <div class="container">
            <div class = "row">
                <table class="table table-striped styled-table col-sm-12" >  
                    <thead style={{textAlign:"center"}}>  
                        <tr>  
                            <th>Sr. No</th>
                            <th>Date</th>  
                            <th>Name</th>
                            <th>Email</th>
                            <th>Number</th>
                            <th>Roles Interested in</th>
                            <th>Message</th>
                            <th>Contacted?</th>  
                        </tr>  
                    </thead>  
                    <tbody style={{textAlign:"center"}}>
                    {
                        loading ? <p>Loading...</p> :
                        contacts.map((contact) => {
                            return (
                                <tr>  
                                    <td>{contact.id}</td>
                                    <td>{contact.date}</td>
                                    <td>{contact.name}</td>
                                    <td>{contact.email}</td>
                                    <td>{contact.number}</td>
                                    <td>{contact.roles}</td>
                                    <td>{contact.message}</td>
                                    <td>
                                        {contact.contacted_by_us}
                                    </td>
                                </tr>
                            );                      
                        })
                    }
                    </tbody>
                </table>
            </div>
        </div>
    );
}